module.exports = __webpack_public_path__ + "/ec1da482c0dc92d6c61757ed6584426d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/black-bar-announcements/assets/number_1.svg
 ** module id = 1047
 ** module chunks = 0
 **/